import {Gender} from '@/constants/enums';
import {DetailItem} from './ViewProfile/ProfileDetailItem';
import {ProfileDataSection} from './ViewProfile/ProfileDetailsSection';
import {authDataSelector} from '@/services/redux/selectors';
import {useSelector} from 'react-redux';
import {ProfileImageSection} from './ProfileImage';
import {ageFromDate} from '@/utils/common_functions';

export function ProfileDetails({onEdit}: {onEdit: () => void}) {
  const profileData = useSelector(authDataSelector);

  return (
    <div className="flex flex-col gap-6 xl:gap-10 w-full">
      {/* profile image */}
      <ProfileImageSection src={profileData?.photo_url ?? ""} isEditing={false} onEdit={onEdit} />

      {/* Contact Info Card */}
      <ProfileDataSection title="Contact Information">
        <div className="flex flex-col gap-5">
          {/* Address */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
            <DetailItem
              truncate
              label="Email ID"
              value={profileData?.email_id}
              icon={'email'}
            />
            <DetailItem
              label="Phone Number"
              value={profileData?.phone}
              icon={'phone'}
            />
          </div>
          <DetailItem
            label="Address"
            value={profileData?.address}
            icon={'pin'}
          />
        </div>
      </ProfileDataSection>

      {/* Personal Details Card */}
      <ProfileDataSection title="Personal Details">
        <div className="grid grid-cols-2 gap-5">
          {/* Age */}
          <DetailItem
            label="Age"
            value={ageFromDate(profileData?.dob ?? "")?.toString()}
            icon={'calender'}
          />

          {/* Gender */}
          <DetailItem
            label="Gender"
            value={Gender[profileData?.gender!]}
            icon={'gender'}
          />
          {/* Weight */}
          <DetailItem
            label="Weight"
            value={profileData?.weight ? profileData?.weight?.toString() + ' kg' : 'N/A'}
            icon={'weight'}
          />
          {/* Height */}
          <DetailItem
            label="Height"
            value={profileData?.height ? profileData?.height?.toString() + ' cm' : 'N/A'}
            icon={'height'}
          />
        </div>
      </ProfileDataSection>
    </div>
  );
}
